<template>
   <path d="M14.0007 25.6667C7.55715 25.6667 2.33398 20.4435 2.33398 14C2.33398 7.55654 7.55715 2.33337 14.0007 2.33337C20.4442 2.33337 25.6673 7.55654 25.6673 14C25.6673 20.4435 20.4442 25.6667 14.0007 25.6667ZM14.0007 23.3334C16.476 23.3334 18.85 22.35 20.6003 20.5997C22.3507 18.8494 23.334 16.4754 23.334 14C23.334 11.5247 22.3507 9.15072 20.6003 7.40038C18.85 5.65004 16.476 4.66671 14.0007 4.66671C11.5253 4.66671 9.15133 5.65004 7.40099 7.40038C5.65065 9.15072 4.66732 11.5247 4.66732 14C4.66732 16.4754 5.65065 18.8494 7.40099 20.5997C9.15133 22.35 11.5253 23.3334 14.0007 23.3334Z" fill="white"></path>
   <path d="M8.16602 14L12.8327 17.5L19.8327 10.5" stroke="white" stroke-width="2"></path>
<!--   <circle cx="10" cy="10.5" r="9" stroke="white" stroke-width="2"></circle>
   <path d="M5.00879 10.0106L8.99799 13.9997L14.9909 8.00684" stroke="white" stroke-width="2"></path>-->
</template>

<script>
    export default {
        name: 'icon-success'
    }
</script>